// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentsMobile_root__1Z912","item":"PaymentsMobile_item__3gzrG","label":"PaymentsMobile_label__29u7I","amount":"PaymentsMobile_amount__1Gb5k"};